import React from 'react';
import {Field} from 'redux-form';
import {Form, Row, Col} from 'react-bootstrap';
import Button from '@material-ui/core/Button';
import * as fields from 'components/common/fields';
import * as validators from 'utils/validators';
import {makeForm, getStateMap, getStateOptions, countryOptions, countryMap} from 'utils/common';
import {isKluwellAdmin} from 'utils/permissions';

class SchoolForm extends React.Component {
  render() {
    const {country: {value: selectedCountryCode} = {}, user, isUpdate, handleSubmit, pristine, submitting} = this.props;
    return (
      <Form onSubmit={handleSubmit}>
        <Row>
          <Col md={6}>
            <Field name="name" label="Name" component={fields.Input} required validate={[validators.isRequired]} />
          </Col>
          <Col md={6}>
            <Field
              name="phoneNumber"
              label="Phone Number"
              component={fields.Input}
              required
              validate={[validators.isRequired, validators.isPhoneNumber]}
            />
          </Col>
          <Col md={12}>
            <Field name="addressLine1" label="Address Line 1" component={fields.Input} />
          </Col>
          <Col md={6}>
            <Field name="suburb" label="Suburb" component={fields.Input} required validate={[validators.isRequired]} />
          </Col>
          <Col md={6}>
            <Field
              name="postcode"
              label="Postcode"
              component={fields.Input}
              required
              validate={[validators.isRequired]}
            />
          </Col>
          <Col md={6}>
            <Field
              key={selectedCountryCode}
              name="state"
              label="State"
              labelKey="label"
              valueKey="value"
              component={fields.Select}
              options={getStateOptions(selectedCountryCode)}
            />
          </Col>
          <Col md={6}>
            <Field
              name="country"
              label="Country"
              component={fields.Select}
              options={countryOptions}
              required
              validate={[validators.isRequired]}
            />
          </Col>
          {isKluwellAdmin(user.role) && (
            <Col md={12}>
              <Field name="notes" label="Notes" component={fields.Textarea} />
            </Col>
          )}
          {isUpdate && (
            <Col md={12}>
              <Field id="logo" name="logo" label="Select Logo" component={fields.FileField} />
            </Col>
          )}
          <Col xs={12}>
            <Button type="submit" variant="contained" color="primary" fullWidth disabled={pristine || submitting}>
              Submit
            </Button>
          </Col>
        </Row>
      </Form>
    );
  }
}

const mapStateToProps = {
  Creation: (state) => {
    return {
      user: state.account.get('user').toJS(),
      initialValues: {
        country: {value: 'AU', label: 'Australia'},
      },
    };
  },
  Update: (state) => {
    const currentSchool = state.schools.get('currentSchool').toJS();
    const countryCode = currentSchool.country;
    return {
      user: state.account.get('user').toJS(),
      isUpdate: true,
      initialValues: {
        ...currentSchool,
        state: {
          value: currentSchool.state,
          label:
            currentSchool.state === '' ? 'Please select your state' : getStateMap(countryCode)[currentSchool.state],
        },
        country: {value: countryCode, label: countryMap[countryCode]},
      },
    };
  },
};

export default {
  Creation: makeForm(SchoolForm, 'SchoolForm.Creation', mapStateToProps.Creation, null, ['country']),
  Update: makeForm(SchoolForm, 'SchoolForm.Update', mapStateToProps.Update, null, ['country']),
};
